module.exports = __webpack_public_path__ + "img/tkconnect_logo.1fb5e295.png";